class Guid {
    constructor(id) {
        this.id = id.toLowerCase();
    }
    static empty() {
        return Guid.emptyGuid;
    }
    static newGuid() {
        return new Guid(Guid.s4() +
            Guid.s4() +
            "-" +
            Guid.s4() +
            "-" +
            Guid.s4() +
            "-" +
            Guid.s4() +
            "-" +
            Guid.s4() +
            Guid.s4() +
            Guid.s4());
    }
    static regex(format) {
        switch (format) {
            case "x":
            case "X":
                return /\{[a-z0-9]{8}(?:-[a-z0-9]{4}){3}-[a-z0-9]{12}\}/i;
            default:
                return /[a-z0-9]{8}(?:-[a-z0-9]{4}){3}-[a-z0-9]{12}/i;
        }
    }
    static s4() {
        return Math.floor((1 + Math.random()) * 0x10000)
            .toString(16)
            .substring(1);
    }
    toString(format) {
        switch (format) {
            case "x":
            case "X":
                return "{" + this.id + "}";
            default:
                return this.id;
        }
    }
    valueOf() {
        return this.id;
    }
}
Guid.emptyGuidString = "00000000-0000-0000-0000-000000000000";
Guid.emptyGuid = new Guid(Guid.emptyGuidString);

//# sourceMappingURL=Guid.js.map
